/**
 * @file 商品详情页
 * @author chengyuan06@baidu.com
 */
import app from '@app';
import {Component} from 'san';
import './index.scss';
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';
import {sendLog} from '@utils/log';
import filter from '@utils/filter';
import {UA} from '@utils/ua';
import {openAppNaPage, openAppSwanPage, openBdboxSwanPage} from '@utils/open-app';
import network from '@utils/network';
import api from '@config/api';

const xss = require('xss');

const NEW_CHANNEL_NUMBER = '1024447y';
const INVOKE_CHANNEL_NUMBER = '1024447z';
const ACTIVITY_NEW_CN = '1024448k';
const ACTIVITY_INVOKE_CN = '1024448l';

export default class AppComponent extends Component {
    constructor(opts) {
        super(opts);
    }

    static template = `
        <div class="wrap">
            <div class="goods-head">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" s-for="item in goodsDetailData.imgList">
                            <img src="{{item.url}}">
                        </div>
                    </div>
                    <!-- 分页器 -->
                    <div class="swiper-pagination"></div>
                </div>
                <!-- 气泡部分 -->
                <div class="swiper-container-bubble" s-if="bubbleVisible">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" s-for="item in goodsDetailData.msgList">
                            <div class="bubble">
                                <img class="cover" src="{{item.avatar}}">
                                <div class="text ellipsis">{{item.msg}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 有优惠卷 -->
                <div class="coupon-price-container"
                    s-if="goodsCoupons.length > 0"
                    on-click="openAppGoodsDetailPage">
                    <div class="price-text">
                        劵后<span class="rmb">¥</span>
                        <span class="present-price">{{presentPrice | getPriceNum}}</span>
                        <span
                            class="original-price"
                            s-if="{{goodsDetailData.price
                                && goodsDetailData.price> presentPrice}}"
                        >
                            ¥{{goodsDetailData.price | getPriceNum}}
                        </span>
                        <span class="sale-num" s-if="{{goodsDetailData.payNum > 0}}">
                            已售{{  payNumToFloat(goodsDetailData.payNum)}}件
                        </span>
                    </div>
                    <div class="coupon-container" on-click="openAppGoodsDetailPage">
                        <div class="coupon--tiny" s-for="item in goodsCoupons">
                            <span>{{item.name}}</span>
                        </div>
                        <div class="coupons-box">
                            <span>领劵</span>
                            <img src="{{rightRed}}">
                        </div>
                    </div>
                </div>
                <!-- 没有优惠卷 -->
                <div class="price-container" s-if="goodsCoupons.length == 0">
                    <div class="price-text">
                        <span class="rmb">¥</span>
                        <span class="present-price">{{presentPrice | getPriceNum}}</span>
                        <span
                            class="original-price"
                            s-if="{{goodsDetailData.originalPrice
                                && goodsDetailData.originalPrice > presentPrice}}"
                        >
                            ¥{{goodsDetailData.originalPrice | getPriceNum}}
                        </span>
                        <span class="sale-num" s-if="{{goodsDetailData.payNum > 0}}">
                            已售{{payNumToFloat(goodsDetailData.payNum)}}件
                        </span>
                    </div>
                </div>
                <div class="goods-info-container">
                    <div class="goods-name">
                        {{goodsDetailData.title}}
                    </div>
                </div>
            </div>

            <!-- APP1.9.0新人专享优惠卷 -->
            <div class="new-user-coupon"
                s-if="goodsDetailData.cardArea.length > 0"
                on-click="openAppGoodsDetailPage('activity')"
            >
                <img src="{{goodsDetailData.cardArea[0].img}}">
            </div>
            <div class="separator"></div>
            <div class="server-info">
                <div class="mail"><span>快递</span> 全国包邮</div>
                <div class="ensure">
                    <img src="{{ensure}}">
                    <span s-if="{{goodsDetailData.ensure}}"> 七天退换无忧 ·</span>
                    <span> 平台消费保障</span>
                </div>
            </div>
            <div class="separator"></div>
            <div class="shop-container" on-click="openAppShopPage">
                <div class="shop-info">
                    <img class="shop-pic" src="{{goodsDetailData.head.cover || defaultShopAvatar}}">
                    <div class="shop-desc">
                        <p class="shop-desc__title">{{goodsDetailData.head.name}}</p>
                        <p class="shop-desc__subtitle">
                            <span>消保金</span>
                            <span>已认证</span>
                        </p>
                    </div>
                    <div class="shop-linke-btn">
                        <span>进店</span>
                        <img src="{{rightGrey}}">
                    </div>
                </div>
            </div>

            <!--直播部分-->
            <div
                class="living-container"
                s-if="{{goodsDetailData.living.length > 0}}"
                on-click="openAppGoodsDetailPage"
            >
                <div class="living-box">
                    <div class="living-log">
                        <img src="{{livingLog}}" />
                        <span>直播中</span>
                    </div>
                    <div class="swiper-container-living">
                        <div class="swiper-wrapper">
                            <div class="living-title ellipsis swiper-slide"s-for="item in goodsDetailData.living">
                                {{item}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="line-after-shop-info" s-if="!goodsDetailData.living.length && shopRecList.length > 2"></div>

            <!-- 店铺推荐 -->
            <div class="others" s-if="shopRecList.length > 2">
                <div class="recommend">
                    <span>店铺推荐</span>
                    <span class="more" on-click="openAppShopPage">
                        <span>查看更多</span>
                        <img src="{{rightGrey}}">
                    </span>
                </div>
                <div class="goods-list">
                    <div class="item" s-for="item in shopRecList">
                        <img src="{{item.cover.url}}" on-click="clickGoodsPicToDetail(item.skuId)">
                        <div class="goods-info ellipsis">{{item.title}}</div>
                        <div class="price">¥{{item.price | getPriceNum}}</div>
                    </div>
                </div>
            </div>
            <div class="detail-container">
                <div class="title">
                    <img class="left-line" src="{{line}}">
                    <span>详情介绍</span>
                    <img class="right-line" src="{{line}}">
                </div>
                <section>
                    <div class="subtitle">规格参数</div>
                    <div class="goods-standard">
                        <template s-for="item in goodsDetailData.platformProperty">
                            <div class="goods-standard-item ellipsis">{{item.name}}</div>
                            <div class="goods-standard-item ellipsis">
                                <span class="goods-standard-item--strong">{{item.value}}</span>
                            </div>
                        </template>
                    </div>
                </section>
                <div class="separator"></div>
                <section>
                    <div class="subtitle detail">商品详情</div>
                    <div class="goods-img" s-html="{{detailInfo}}"></div>
                </section>
            </div>
            <!-- 购买须知 -->
            <div class="separator"></div>
            <div class="agreement-container">
                <div class="text">购买须知</div>
                <div class="content">
                    <div class="row">
                        <div class="title"><span class="point"></span>正品保障</div>
                        <div class="value">平台中珠宝玉翠品类的商品，全系商家商品，一物一证（原石商品除外），证书均由省级以上（含）质检机构出具，支持复检</div>
                    </div>
                    <div class="row">
                        <div class="title"><span class="point"></span>全场包邮</div>
                        <div class="value">平台全场包邮（新疆、西藏等偏远地区，可能存在物流较慢或无法送达的情况）</div>
                    </div>
                    <div class="row">
                        <div class="title"><span class="point"></span>七天无理由退换</div>
                        <div class="value">平台商品支持七天无理由退换货（原石、定制类商品除外）</div>
                    </div>
                    <div class="row">
                        <div class="title"><span class="point"></span>特殊商品说明</div>
                        <div class="value">平台中二手书商品，全系商家商品，由于二手书存在稀缺性特点，可能存在售价高于书籍定价的情况，用户购买前请注意</div>
                    </div>
                    <div class="row">
                        <div class="title"><span class="point"></span>联系我们</div>
                        <div class="value">如需咨询商品、退换货、售后等服务，可在商品详情页或订单页中直接联系商家。如需咨询平台相关问题，可在我的 - 联系平台中联系到平台客服</div>
                    </div>
                </div>
            </div>
            <div class="recommend-goods">
                <div class="title">
                    <img class="left-line" src="{{line}}">
                    好物推荐
                    <img class="right-line" src="{{line}}">
                </div>
                <div class="list">
                    <div class="item" s-for="item in recList">
                        <div
                            class="goods-img"
                            style="background-image: url({{item.cover.url}})"
                            on-click="clickGoodsPicToDetail(item.skuId)"
                        ></div>
                        <div class="info-box">
                            <div class="text">{{item.title}}</div>
                            <div class="coupon-container" s-if="item.coupon.length > 0">
                                <div class="coupon--tiny" s-for="one in item.coupon)">
                                    <span>{{one.name}}</span>
                                </div>
                            </div>
                            <div class="price-box">
                                <div class="symbol">¥</div>
                                <div class="price">{{item.price | getPriceNum}}</div>
                                <div s-if="item.originalPrice && item.originalPrice > item.price" class="old-price">
                                    ¥{{item.originalPrice | getPriceNum}}
                                </div>
                                <div class="mail" s-if="{{item.freeMail != 0}}">包邮</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="go-to-app" on-click="openAppHaoWuTabPage">
                    <u>去古物潮玩APP查看全部商品</u>
                </div>
            </div>
            <div class="bottom-box">
                <div class="log-list">
                    <div class="box" on-click="openAppGoodsDetailPage">
                        <img src="{{callserver}}" />
                        <div class="text">商家</div>
                    </div>
                    <div class="box" on-click="openAppGoodsDetailPage">
                        <img src="{{shopLog}}" />
                        <div class="text">店铺</div>
                    </div>
                    <div class="box" on-click="openAppGoodsDetailPage">
                        <img src="{{collection}}" />
                        <div class="text">收藏</div>
                    </div>
                </div>
                <div
                    on-click="buyClick"
                    class="btn-coupon-price"
                    s-if="{{goodsCoupons.length > 0 && goodsDetailData.productStock != 0}}">
                    <div class="text">
                        <div>领劵购买</div>
                        <div class="coupon-price">劵后¥{{presentPrice | getPriceNum}}</div>
                    </div>
                </div>
                <div class="btn-originalPrice"
                    on-click="buyClick"
                    s-else-if="{{goodsDetailData.productStock != 0}}"
                >
                    <div class="text">立即购买</div>
                </div>
                <div class="btn-finished"
                    s-else-if="{{goodsDetailData.productStock === 0}}"
                >
                    <div class="text">已销罄</div>
                </div>
            </div>

            <!-- 蒙层 -->
            <div class="{{isMaskShow ? 'mask' : 'hidden'}}" on-touchmove="preventTouchmove"></div>

            <!-- 引导下载活动提示弹窗 -->
            <div class="{{isDownloadShow ? 'download-window' : 'hidden'}}" on-touchmove="preventTouchmove">
				<div class="container">
                    <div class="pic" on-click="openAppGoodsDetailPage('activity')">
						<img src="{{goodsDetailData.buyDu.img}}"/>
					</div>
					<div class="close-btn" on-click="closeDownloadWindow">
						<img src="https://gemapp.cdn.bcebos.com/pic/ghiuan73f62283624521c7ae"/>
					</div>
				</div>
            </div>
        </div>
    `;

    static components = {};

    static filters = {
        getPriceNum: filter.getPriceNum
    };

    initData() {
        // 同步商品详情数据
        let goodsDetailData = window.INITIAL_DATA.data;
        let presentPrice = goodsDetailData.price || 0;
        // 商品详情富文本数据，已经过转义过滤
        let detailInfo = xss(goodsDetailData.detailInfo);
        let {skuId, shopId} = goodsDetailData;
        // 获取店铺推荐和好物推荐的数据
        network.get(api.goodsDetail.shopRec, {skuId, shopId}).then(data => {
            // 店铺推荐的数据
            this.data.set('shopRecList', data.shop);
            // 好物推荐的数据
            this.data.set('recList', data.rec);
        });

        // 获取商品优惠卷
        network.get(api.goodsDetail.coupon, {skuId}).then(data => {
            let couponList = (data.list || []).slice(0, 3);
            const couponPrice = data.couponPrice;
            if (couponPrice) {
                this.data.set('presentPrice', couponPrice);
            }
            this.data.set('goodsCoupons', couponList);
        });
        return {
            presentPrice,
            goodsDetailData,
            // 商品详情富文本数据，已经过转义过滤
            detailInfo,
            // 静态图片路径
            defaultShopAvatar: 'https://gemapp.cdn.bcebos.com/pic/qi7z2ng9d5fdb9d93516697e',
            shopLog: 'https://gemapp.cdn.bcebos.com/pic/619cmdxp210928d4d3396cba',
            collection: 'https://gemapp.cdn.bcebos.com/pic/z74747f2da622457dbb0202b',
            collected: 'https://gemapp.cdn.bcebos.com/pic/uigitmdj8b0c844df6bb5948',
            callserver: 'https://gemapp.cdn.bcebos.com/pic/3294nuymcba138b27323f6af',
            rightRed: 'https://gemapp.cdn.bcebos.com/pic/w0d4ghi1c0c54ade2ddfb79e',
            rightGrey: 'https://gemapp.cdn.bcebos.com/pic/m6324xc2f044416c090f118c',
            newGoods: 'https://gemapp.cdn.bcebos.com/pic/y18yxh5b3489aca86b22e163',
            line: 'https://gemapp.cdn.bcebos.com/pic/ej1gk4bec7d6958de620141a',
            appLogo: 'https://gemapp.cdn.bcebos.com/pic/p1ngrxsj77b6a9b10ed0ddc0',
            closeBtn: 'https://gemapp.cdn.bcebos.com/pic/fd3855rm49690f4dbf0af1a6',
            ensure: 'https://gemapp.cdn.bcebos.com/pic/fima4cnufb2bcbfc896e67f9',
            livingLog: 'https://gemapp.cdn.bcebos.com/pic/edgeyjimd872b1640866fbe2',
            downloadBgImage: 'https://gemapp.cdn.bcebos.com/pic/m6321t9r5b061a154ac1c999',
            appLogSquare: 'https://gemapp.cdn.bcebos.com/pic/n6thgfkna5ff4c78e6096180',
            isMaskShow: false,
            isDownloadShow: false,
            isActivityShow: false
        };
    }

    static computed = {
        bubbleVisible() {
            let msgList = this.data.get('goodsDetailData').msgList || [];
            let isBDSpider = UA.indexOf('Baiduspider') > 0;
            return msgList.length > 5 && !isBDSpider;
        }
    };

    attached() {
        this.goodsIsOffline();
        this.importSwiper();
        // 展现打点
        sendLog('pv');
        // 新人优惠券打点
        if (this.data.get('goodsDetailData.cardArea.length') > 0) {
            sendLog('view', {
                value: 'appNewUserCoupon',
                ext: {
                    'coupon_id': this.data.get('goodsDetailData.cardArea[0].couponId'),
                    'du_id': this.data.get('goodsDetailData.cardArea[0].du')
                }
            });
        }
    }

    // 判断商品是否下架
    goodsIsOffline() {
        // FIXME 临时方案，后续需要优化
        if (this.data.get('goodsDetailData.isOffline') === 1) {
            alert('商品已下架，页面将在3s后跳走'); // eslint-disable-line no-alert
            setTimeout(() => {
                window.location = 'http://www.guwuchaowan.com/web/home/index';
            }, 3000);
        }
    }

    // 禁止页面滑动
    preventTouchmove(event) {
        event.preventDefault();
    }

    // 点击立即购买区域,判断是否显示活动弹窗
    buyClick() {
        // 如果有活动链接，认为配置了活动，显示活动弹窗
        const activityImg = this.data.get('goodsDetailData.buyDu.img');
        if (activityImg) {
            this.data.set('isDownloadShow', true);
            this.data.set('isMaskShow', true);
        }
        else {
        // 没有活动直接打开app，不显示弹窗
            this.openAppGoodsDetailPage();
        }
    }

    // 点击关闭按钮,隐藏下载提示框
    closeDownloadWindow() {
        this.data.set('isDownloadShow', false);
        this.data.set('isMaskShow', false);
        this.data.downloadBtnJumpCase = '';
    }

    // 点击活动图片跳转到H5页面
    jumpToH5(url) {
        window.location.href = url;
    }

    /**
     * 获取商品的优惠卷信息
     * @param {number} skuId 商品ID
     * @return {Object} 返回一个对象数组
     */
    async getGoodsCoupons(skuId) {
        await network.get(api.goodsDetail.coupon, {skuId}).then(res => {
            return res.data.data.list;
        });
    }

    /**
     * 点击商品图片跳转到商品详情页
     * @param {number} skuId 要转换的数字
     */
    clickGoodsPicToDetail(skuId) {
        // 拆分URl拼接skuId参数
        let url = window.location.href.split('?')[0] + '?skuId=' + skuId;
        window.location = url;
    }

    /**
     * 将销量进行转换,大于10000的转换成1w保留一位小数
     * @param {number} num 要转换的数字
     * @return {string | sumber} 返回一个字符串或者数字
     */
    payNumToFloat(num) {
        if (num < 10000) {
            return num;
        }

        num = num / 10000;
        num = num.toFixed(1);
        if (num[num.length - 1] === '0') {
            return num + ' w';
        }

        return num.substr(0, num.length - 2) + 'w';
    }

    openAppHaoWuTabPage() {
        let params = {
            type: 0,
            ext: {
                page: 'goods'
            }
        };

        let opts = {
            useCopy: true,
            newCN: NEW_CHANNEL_NUMBER,
            invokeCN: INVOKE_CHANNEL_NUMBER
        };
        openAppNaPage(params, opts);
    }

    openAppShopPage() {
        const {shopId} = this.data.get('goodsDetailData');
        let params = {
            path: `/pkg-biz/pages/shop/index?shopId=${shopId}`
        };

        let opts = {
            useCopy: true,
            newCN: NEW_CHANNEL_NUMBER,
            invokeCN: INVOKE_CHANNEL_NUMBER
        };
        openAppSwanPage(params, opts);
    }

    openAppGoodsDetailPage(type = '') {
        const newCN = type === 'activity' ? ACTIVITY_NEW_CN : NEW_CHANNEL_NUMBER;
        const invokeCN = type === 'activity' ? ACTIVITY_INVOKE_CN : INVOKE_CHANNEL_NUMBER;

        const {skuId} = this.data.get('goodsDetailData');
        let params = {
            path: `pages/goods-detail/index?skuId=${skuId}`
        };

        if (type === 'activity') {
            sendLog('clk', {
                value: 'appNewUserCoupon',
                ext: {
                    'coupon_id': this.data.get('goodsDetailData.cardArea[0].couponId'),
                    'du_id': this.data.get('goodsDetailData.cardArea[0].du')
                }
            });
        }
        let opts = {
            useCopy: true,
            newCN,
            invokeCN
        };
        openBdboxSwanPage(params, opts);
    }

    // 商品轮播图和气泡轮播图
    importSwiper() {
        new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            paginationType: 'fraction',
            autoplay: 0
        });

        new Swiper('.swiper-container-bubble', {
            loop: true,
            speed: 500,
            slidesPerView: 1,
            direction: 'vertical',
            autoplay: 1000
        });

        // 当数据未单条时不进行滚动
        if ((this.data.get('goodsDetailData.living') || []).length > 1) {
            new Swiper('.swiper-container-living', {
                loop: true,
                speed: 500,
                slidesPerView: 1,
                direction: 'vertical',
                autoplay: 5000
            });
        }
    }
}

app(AppComponent, '#app');
